import mSearchInput1 from './SearchInput1.vue'
import mSearchInput2 from './SearchInput2.vue'
import mSearchInput200 from './SearchInput200.vue'
import mSearchInput301 from './SearchInput301.vue'
import mSearchInput500 from './SearchInput500.vue'
import mSearchInput501 from './SearchInput501.vue'


export const searchInputs = {
    mSearchInput1,
    mSearchInput2,
    mSearchInput200,
    mSearchInput301,
    mSearchInput500,
    mSearchInput501,

}